module.exports = __webpack_public_path__ + "img/background1.49e8308e.png";